/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{ "rawString": ".root_ffc3a631{position:relative;padding:5px 38px}.root_ffc3a631 .ms-Link{font-size:12px}\n" }]);
export var root = "root_ffc3a631";
//# sourceMappingURL=GroupFooter.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib-es2015/components/GroupedList/GroupFooter.scss.js
// module id = 765
// module chunks = 0